import { SubmissionCardMedia } from './Media'

export { SubmissionCardMedia }
